import { render, staticRenderFns } from "./commissioniBeneficiari.vue?vue&type=template&id=ad8d7e40&"
import script from "./commissioniBeneficiari.vue.ts?vue&type=script&lang=ts&"
export * from "./commissioniBeneficiari.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports